import clsx from 'clsx';
import { normalizeLocalizedHtml } from 'common/utils/url';
import { useTranslation } from 'next-i18next';

import { IHeadingType } from './types';

export const ContentHeading = ({
  className: classNameProp,
  dark,
  type,
  children,
}: IHeadingType) => {
  const { i18n } = useTranslation();
  const className = clsx('font-semibold', classNameProp, {
    'text-white/90': dark,
    'text-dark-blue': !dark,
  });

  const normalizeHtml = (value: string) => normalizeLocalizedHtml(value, i18n.language);

  const getChildren = () => {
    if (Array.isArray(children)) {
      return children.reduce((acc, item) => {
        if (item?.props?.text) {
          return acc + item.props.text;
        }
        return acc;
      }, '');
    }
    return children;
  };

  switch (type) {
    case 'h1':
      return (
        <h1
          dangerouslySetInnerHTML={{ __html: normalizeHtml(getChildren()) }}
          className={clsx('heading-1 mb-6 mt-20', className)}
        />
      );
    case 'h2':
      return (
        <h2
          dangerouslySetInnerHTML={{ __html: normalizeHtml(getChildren()) }}
          className={clsx('heading-2 mb-3 mt-20 lg:mb-6', className)}
        />
      );
    case 'h3':
      return (
        <h3
          dangerouslySetInnerHTML={{ __html: normalizeHtml(getChildren()) }}
          className={clsx('heading-3 mb-3 mt-16', className)}
        />
      );
    case 'h4':
      return (
        <h4
          dangerouslySetInnerHTML={{ __html: normalizeHtml(getChildren()) }}
          className={clsx('heading-4 mb-2 mt-8', className)}
        />
      );
    case 'h5':
      return (
        <h5
          dangerouslySetInnerHTML={{ __html: normalizeHtml(getChildren()) }}
          className={clsx('heading-4 mb-2 mt-8', className)}
        />
      );
    case 'h6':
      return (
        <h6
          dangerouslySetInnerHTML={{ __html: normalizeHtml(getChildren()) }}
          className={clsx('heading-4 mb-2 mt-8', className)}
        />
      );
    default:
      return <></>;
  }
};
